// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `table.AutoEditForm {
    width: 100%;
}

table.AutoEditForm td {
    padding: 0.25em;
    white-space: nowrap;
}

table.AutoEditForm td:first-child {
    max-width: 10em;
    text-overflow: ellipsis;
    overflow: hidden;
}

table.AutoEditForm td:nth-child(2) {
    width: 99%;
}

table.AutoEditForm label > input {
    margin-right: 0.5em;
}

table.AutoEditForm td:nth-child(2) > * {
    width: 100%;
}`, "",{"version":3,"sources":["webpack://./qwc2/components/style/AutoEditForm.css"],"names":[],"mappings":"AAAA;IACI,WAAW;AACf;;AAEA;IACI,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,uBAAuB;IACvB,gBAAgB;AACpB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,WAAW;AACf","sourcesContent":["table.AutoEditForm {\n    width: 100%;\n}\n\ntable.AutoEditForm td {\n    padding: 0.25em;\n    white-space: nowrap;\n}\n\ntable.AutoEditForm td:first-child {\n    max-width: 10em;\n    text-overflow: ellipsis;\n    overflow: hidden;\n}\n\ntable.AutoEditForm td:nth-child(2) {\n    width: 99%;\n}\n\ntable.AutoEditForm label > input {\n    margin-right: 0.5em;\n}\n\ntable.AutoEditForm td:nth-child(2) > * {\n    width: 100%;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
